<template>
  <div style="display: flex;align-items: center">
    <el-tooltip
      v-show="showWarningImage"
      :content="warningImageTip"
      placement="right-end"
    >
      <i
        class="el-icon-warning red"
        style="cursor: pointer;font-size: 14px;"
      />
    </el-tooltip>
    <cargo-advance-select
      :select-type="TYPE_NAMES.basic_data_Company"
      :method-params="methodParams"
      :hand-trigger-value="$store.getters.currentOfficeUuid"
      :clear-not-match="clearNotMatch"
      filterable
      :disabled="disabled"
      :default-value="value"
      :tag-value="tagValue"
      :headers="headers"
      :fields="fields"
      :tag-name="tagName"
      :placeholder="placeholder"
      :static-options="staticOptions"
      @enter="$emit('enter')"
      @parentCallBack="onParentCallBack"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { getCustomerByRole } from '@/api/booking/job'
import { cacheName, cache } from '@/utils/cacheManager'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { AdvanceSelect } from '@/utils/class/AdvanceSelect'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'

// 销售自己的客户
let salesCompanies = null

export default {
  name: 'SalesCompanySelectWithCheck',
  components: { cargoAdvanceSelect },
  props: {
    methodParams: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    value: { type: Number, default: 0 },
    tagValue: { type: String, default: '' },
    headers: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    tagName: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    clearNotMatch: { type: Boolean, default: false },
    useAccountObjectControlMode: { type: Boolean, default: true }, // 是否使用配置参数：AccountObjectControlMode（结算单位控制模式）
    job: { type: Object, default: null }
  },
  data() {
    return {
      TYPE_NAMES,
      staticData: null,
      staticOptions: null,
      accountObjectControlMode: false, // 结算单位控制模式
      showWarningImage: false,
      warningImageTip: '',
      warningValue: 0
    }
  },
  computed: {
    useStaticOptions() {
      return (this.useAccountObjectControlMode && this.accountObjectControlMode || !this.useAccountObjectControlMode) && !!this.staticData
    }
  },
  watch: {
    value() {
      this.resetStaticOptions()
      if (this.warningValue !== this.value) {
        this.checkCompany(this.value, false)
      }
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1
      }
    },
    useStaticOptions() {
      this.resetStaticOptions()
    }
  },
  async created() {
    if (!this.$store.getters.isAdmin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
      if (!salesCompanies) {
        await getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
          salesCompanies = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
        })
      }
      this.staticData = salesCompanies
    }
    this.resetStaticOptions()
    this.checkCompany(this.value, false)
  },
  methods: {
    async onParentCallBack(data) {
      const val = data.value || 0
      await this.checkCompany(val, true)
      this.$emit('input', val)
      this.$emit('change', val)
    },
    // 验证合作伙伴信控
    async checkCompany(companyId, showAlert) {
      this.showWarningImage = false
      this.warningImageTip = ''
      this.warningValue = companyId
      if (!companyId) return
      await cache.load(cacheName.CONFIG)
      if (parseInt(cache.config.get('creditOpen')) === 1) {
        await CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
          if (!res.data || res.data.length <= 0) return
          const credit = res.data[0]
          if (credit && credit.blacklist) {
            if (showAlert) {
              this.$message.warning(this.$t('Message.PartnersBeenAddedToBlacklist'))
              return
            }
          }
          for (const item of res.data) {
            this.setCreditColor(item, showAlert)
          }
        })
      }
    },
    setCreditColor(credit, showAlert) {
      if (!credit) return
      if (credit.amountExceeded || credit.dateExceeded) {
        let s = ' '
        if (credit.amountExceeded) { s += this.$t('Partners.credit_limit') + ' ' }
        if (credit.dateExceeded) { s += this.$t('Partners.accountPeriod') + ' ' }
        const toolTip = this.$t('Partners.parter') + s + this.$t('SeaExport.HasExceeded')
        if (showAlert) {
          this.$message.warning(toolTip)
        }
        this.showWarningImage = true
        this.warningImageTip = toolTip
      }
    },
    resetStaticOptions() {
      this.staticOptions = null
      if (this.useStaticOptions) {
        this.staticOptions = this.staticData
        if (this.staticOptions && !this.clearNotMatch) {
          let tagValue = this.tagValue
          if (!tagValue) {
            const advanceSelect = new AdvanceSelect(TYPE_NAMES.basic_data_Company, {}, null, null, { includeAllItem: false })
            tagValue = advanceSelect.typeInfo.tagValue
          }
          if (this.staticOptions.findIndex(p => p[tagValue]) < 0) {
            const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, tagValue, this.value)
            if (cmp) {
              this.staticOptions = [cmp, ...this.staticOptions]
            }
          }
        }
      }
    }
  }
}
</script>
